import React from 'react';

const Map = () => {
  return (
    <section id="map">
      <div className="w-full">
        <iframe
          title="Carte Ariana, Tunisie"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12835.80394219623!2d10.1291602!3d36.8688509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12e2cb4e31471bf3%3A0x65bc5efbce842198!2sAriana!5e0!3m2!1sfr!2stn!4v1695580800000"
          className="w-full h-[420px]"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </section>
  );
};

export default Map;


